import DeviceUtils from "~/utils/device-utils";

/**
 * PC端配合（postcss-pxtorem）使用
 */
export default defineNuxtPlugin({
  name: "pxtorem-plugin",
  parallel: true,
  setup(nuxtApp) {
    const baseSize = 16;
    const minFontSize = 14;
    const isMobile = DeviceUtils.isMobile();

    function setRem() {
      if (isMobile) return;
      const scale = document.documentElement.clientWidth / 1920;
      let fontSize = baseSize * Math.min(scale, 2);
      if (fontSize < minFontSize) fontSize = minFontSize;
      document.documentElement.style.fontSize = `${fontSize}px`;
    }

    setRem();

    window.addEventListener("resize", setRem);
    nuxtApp.vueApp.onUnmount(() => {
      window.removeEventListener("resize", setRem);
    });
  },
});
